import { Component } from "react";
import { AlertTriangle, RotateCcw, LayoutDashboard } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // Controlled: never surface a raw stack trace to users.
    console.error("ShieldX workspace error", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="grid min-h-[60vh] place-items-center p-6" data-testid="error-boundary">
          <div className="max-w-md rounded-2xl border border-slate-800 bg-slate-900/60 p-8 text-center">
            <AlertTriangle className="mx-auto h-10 w-10 text-amber-400" />
            <h2 className="mt-4 font-display text-lg font-bold text-slate-100">Page Unavailable</h2>
            <p className="mt-1 text-sm text-slate-400">ShieldX could not load this workspace.</p>
            <p className="mt-0.5 font-mono text-[11px] uppercase tracking-widest text-amber-400/80">Temporarily Unavailable</p>
            <div className="mt-6 flex justify-center gap-2">
              <button onClick={() => this.setState({ hasError: false })} className="inline-flex items-center gap-2 rounded-lg border border-slate-700 px-4 py-2 text-sm text-slate-200 hover:border-blue-500/50">
                <RotateCcw className="h-4 w-4" /> Retry
              </button>
              <button onClick={() => { window.location.href = "/app"; }} className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-500">
                <LayoutDashboard className="h-4 w-4" /> Return to Dashboard
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
